// extracted by mini-css-extract-plugin
export default {"layout":"index_layout__cmVGp","emptydashboard":"index_emptydashboard__fNFKm","moredetails":"index_moredetails__bRICQ","notificationContainer":"index_notificationContainer__rD9gK"};